import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../../config/index';
import { connect } from "trim-redux";
import {InputAdornment, MenuItem, TextField, Typography} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../../components/elements/LoadingButton";
import { Styles } from '../../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {isAdmin, rolesWithName} from "../../../../../config/Permissions";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import RayaField from "../../../../components/elements/fields/RayaField";
import MobileField from "../../../../components/elements/fields/MobileField";
import UploadPrivateFile from "../../../fileManager/Components/UploadPrivateFile";
import {loadSetting, updateRedux} from "../../../../../config/Security";
import {currencySymbol} from "../../../../../config/values";
import NumberField from "../../../../components/elements/fields/NumberField";
import SubTitle from "../../../../components/elements/SubTitle";

const AddStockPrice = (props) => {
    const { classes } = props;
    const navigation = useNavigate();

    const [fields, setFields] = useState({
        price: '',
        type: 'normal',
    });
    const [errors, setErrors] = useState({});
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        if (!fields.price) {
            formIsValid = false;
            newErrors.price = t('emptyField');
        }
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('price', fields.price);
        data.append('type', fields.type);


        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/stock-price/add`, data, config);
            loadSetting();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setFields({
                price: '',
                type: 'normal',
            })
            setSubmitLoading(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
        }
    };
    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };


    if (loading) {
        return <AppCardLoaderFields />;
    }

    return (
        <Grid container spacing={2} className="bg-gray-box">
            <CssBaseline />
            <Grid item size={12}>
                <SubTitle>{t('stockPriceChange')}</SubTitle>
            </Grid>
            <Grid item size={12}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('stockType')}
                    name="type"
                    value={fields.type}
                    onChange={handleChange}
                    error={!!errors.type}
                    helperText={errors.type}
                    select
                >
                    <MenuItem value="normal">{t("normalStock")}</MenuItem>
                    <MenuItem value="special">{t("specialStock")}</MenuItem>
                </RayaField>
            </Grid>
            <Grid item size={12}>
                <NumberField
                    fullWidth
                    label={t('stockPrice')}
                    variant="outlined"
                    value={fields.price}
                    endAdornment={currencySymbol}
                    decimals={2}
                    min={0}
                    onChange={(res) => handleInputChange('price', res)}
                />
            </Grid>

            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>

    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(AddStockPrice));
